const TEST = process.env.REACT_APP_TEST_MODE && process.env.REACT_APP_TEST_MODE.toLowerCase() === 'true';

function devHost() {
  if (typeof window !== 'undefined' && window.location?.hostname) {
    return window.location.hostname;
  }
  return process.env.REACT_APP_DEV_HOST || 'localhost';
}

function isPrivateLanHost(host) {
  if (!host || host.endsWith('.local')) return Boolean(host?.endsWith('.local'));

  const parts = host.split('.').map(Number);
  if (parts.length !== 4 || parts.some((n) => Number.isNaN(n))) return false;

  const [a, b] = parts;
  if (a === 10) return true;
  if (a === 172 && b >= 16 && b <= 31) return true;
  if (a === 192 && b === 168) return true;
  return false;
}

function isLocalFrontend() {
  if (typeof window === 'undefined' || !window.location?.hostname) return false;
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1' || isPrivateLanHost(host);
}

const useLocalApi = TEST || isLocalFrontend();
const BASE_URL = useLocalApi ? `http://${devHost()}:8000/` : 'https://www.collectdiv.com/';

const FRONT_URL = useLocalApi ? `http://${devHost()}:3000/` : 'https://www.collectdiv.com/';

const CURRENCY_CODE = 'aud';

const SHIPPING_COST = 1100;

const EXPRESS_SHIPPING_COST = 1600;

const INTERNATIONAL_SHIPPING_COST = 3000;

const NZ_COST = 2000;

export {BASE_URL, CURRENCY_CODE, SHIPPING_COST, EXPRESS_SHIPPING_COST, NZ_COST, INTERNATIONAL_SHIPPING_COST, FRONT_URL, TEST};
